import { createSlice } from "@reduxjs/toolkit";

export const complementaryDataSlice = createSlice({
  name: "complementaryData",
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startComplementaryData: (state) => { state.isLoading = true; },
    setComplementaryData: (state, { payload: { data = null, error = null }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startComplementaryData, setComplementaryData } = complementaryDataSlice.actions;
